import * as React from 'react';
import classnames from 'classnames';
import { Heading } from '@grandvisionhq/elements';

const BrandList = ({ title , children , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('brand-list', className)
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        className: "heading brand-list__title"
    }, title), /*#__PURE__*/ React.createElement("ul", {
        className: "brand-list__content"
    }, children))
;

export { BrandList as default };
//# sourceMappingURL=BrandList.js.map
